var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoverletterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2094 36C28.1505 36 36.2094 27.9411 36.2094 18C36.2094 8.05888 28.1505 0 18.2094 0C8.26822 0 0.209351 8.05888 0.209351 18C0.209351 27.9411 8.26822 36 18.2094 36Z",
    fill: "#E1EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1226 21.0857H21.294V22.6286H15.1226V21.0857ZM15.1226 18H21.294V19.5429H15.1226V18ZM19.7512 10.2857H13.5797C12.7312 10.2857 12.0369 10.98 12.0369 11.8286V24.1714C12.0369 25.02 12.7234 25.7143 13.572 25.7143H22.8369C23.6854 25.7143 24.3797 25.02 24.3797 24.1714V14.9143L19.7512 10.2857ZM22.8369 24.1714H13.5797V11.8286H18.9797V15.6857H22.8369V24.1714Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6767 11.511L23.3494 10.8005L23.0332 11.511L22.3226 11.8272L23.0332 12.1546L23.3494 12.8576L23.6767 12.1546L24.3798 11.8272L23.6767 11.511Z",
    fill: "#1570EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6671 13.8867L16.1876 14.9469L15.1256 15.4296L16.1876 15.9122L16.6671 16.9724L17.1493 15.9122L18.2113 15.4296L17.1493 14.9469L16.6671 13.8867Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverletterIcon);
export default __webpack_public_path__ + "static/media/coverletterIcon.7de18c144cd4292c91dbe2aa97f017b3.svg";
export { ForwardRef as ReactComponent };